import achievements from "./achievements";
import answerTemplates from "./answerTemplates";
import { certificates } from "./certificates";
import { file } from "./file";
import courses from "./courses";
import coursesGroups from "./coursesGroups";
import lessons from "./lessons";
import account from "./account";
import tags from "./tags";
import students from "./students";
import curators from "./curators"
import studentGroups from "./studentGroups";
import user from "./user";
import { bitrix } from "./bitrixStatuses"
import lessonModule from "./lessonModule";
import files from "./files";
import profile from "./profile";
import { emails } from "./email";
import banners from "./banners";
import lessonTheme from "./lessonTheme";
import course from "./course";
import benefits from "./benefits";
import host from "./host";
import phones from "./phones";
import whatsapp from "./whatsapp";
import currency from "./currency";
import documents from "./documents";
import platformPromoEvents from "./platformPromoEvents";
import plan from "./plan";
import news from "./news";
import groupChat from "./groupChat";
import telegramChats from "./telegramChats";
import studentRecurrings from "./studentRecurrings";
import proctoring from "./proctoring";
import * as paymentsystems from './paymentsystems';
import * as xhr from './xhr';
import wheel from "./wheel";
import mailings from "./mailings";
import courseStorage from './courseStorage';
import { transcriptions } from "./transcriptions";
import chats from "./chats";
import ai from "./ai";


const api = {
  account: account,
  achievements: achievements,
  ai: ai,
  answerTemplates: answerTemplates,
  benefits: benefits,
  bitrix,
  certificates: certificates,
  currency: currency,
  documents: documents,
  banners: banners,
  course: course,
  courses: courses,
  coursesGroups: coursesGroups,
  curators: curators,
  lessonTheme: lessonTheme,
  lessonModule: lessonModule,
  emails: emails,
  file: file,
  files: files,
  host: host,
  lessons: lessons,
  plan: plan,
  students: students,
  studentGroups: studentGroups,
  paymentsystems: paymentsystems,
  phones: phones,
  whatsapp: whatsapp,
  platformPromoEvents: platformPromoEvents,
  profile: profile,
  tags: tags,
  user: user,
  news: news,
  groupChat: groupChat,
  telegramChats: telegramChats,
  studentRecurrings: studentRecurrings,
  proctoring: proctoring,
  xhr,
  wheel,
  mailings,
  courseStorage,
  transcriptions,
  chats,
}

export default api;